<template>
  <!-- start service -->
  <div id="service">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-6">
          <h3 style="color: #96bca5;">Advanced Services</h3>
          <h4 style="color:#58585a;">Printer Counters models & features</h4>
          <p>&nbsp;</p>
        </div>
        <div class="col-md-4 col-sm-4" v-for="service in services">
          <div class="media">
            <div class="media-object media-left wow fadeInLeft" data-wow-delay="0.2s">
              <i :class="[service.icon]"></i>
            </div>
            <div class="media-body wow fadeIn">
              <h3 class="media-heading primary">{{service.title}}</h3>
              <p>{{service.info}}</p>
            </div>
          </div>
        </div>
      </div>
      <tryBtn></tryBtn>
    </div>
  </div>
  <!-- end service -->
</template>
<script>
  import tryBtn from './tryBtn'
  export default {
    name: 'slides',
    components: { tryBtn },
    data () {
      return {
        services: [
          {
            title: 'RealTime Printers Monitoring',
            info: 'Print count information collection from your organization’s printers',
            icon: 'fa fa-print'
          },
          {
            title: 'Reports',
            info: 'Printer Counters reports are used to charge clients of Managed Print Services companies accordingly or by IT department of any company to track and monitor the status of printers & automatically collect printer counters data.',
            icon: 'fa fa-bar-chart'
          },
          {
            title: 'History Log',
            info: 'Printer Counters log history print data as the number of pages printed or copied (including page size and color information), printer status, toner or ink level, IP address, model, serial number, MAC address.',
            icon: 'fa fa-history'
          },
          {
            title: 'Customers & Users',
            info: 'Charge customers of Managed Print Services companies according to monthly usgaed generated reports.',
            icon: 'fa fa-dollar'
          },
          {
            title: 'Alerts',
            info: 'Custome rule-based alerts, E-mail alerts, Notification alerts, Error alerts and more...',
            icon: 'fa fa-warning'
          },
          {
            title: 'Simple, Fast and Easy Printers Management',
            info: 'Remotly and Silently update clients to newer versions of Printer Counters with no efforts.',
            icon: 'fa fa-download'
          },
          {
            title: 'Free 60 days',
            info: 'Free 60 days trail, No credit card needed, Start using Printer Counters today.',
            icon: 'fa fa-dollar'
          }
        ]
      }
    },
    computed: {
      active () {
        return this.activeMenu === 'HOME'
      }
    }
  }

</script>
<style>
  #service {
    background-color: #ecf0f5;
  }
</style>



// WEBPACK FOOTER //
// services.vue?00c5b030